import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";
import Seo from "@/components/Seo";

const SECTIONS = [
  {
    heading: "1. Verantwortliche Stelle",
    body: [
      "Verantwortlich für die Datenverarbeitung auf dieser Website ist die Elite Swiss LLC, 7255 Bee Ridge Rd, Sarasota, Florida, USA. Sie erreichen uns per E-Mail unter reni.a90@hotmail.com.",
    ],
  },
  {
    heading: "2. Welche Daten wir verarbeiten",
    body: [
      "Wenn Sie uns über das Kontaktformular oder die Erstgespräch-Anfrage schreiben, verarbeiten wir die von Ihnen angegebenen Daten: Name, E-Mail-Adresse, optional Telefonnummer, Ihr Anliegen, Ihre Nachricht sowie – bei der Erstgespräch-Anfrage – Ihren Wunschtermin und Ihre bevorzugte Tageszeit.",
    ],
  },
  {
    heading: "3. Zweck und Rechtsgrundlage",
    body: [
      "Wir verwenden Ihre Angaben ausschliesslich, um Ihre Anfrage zu beantworten und – falls gewünscht – ein Erstgespräch zu vereinbaren und durchzuführen. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Massnahmen) sowie unser berechtigtes Interesse an der Bearbeitung von Anfragen (Art. 6 Abs. 1 lit. f DSGVO).",
    ],
  },
  {
    heading: "4. Speicherung und Löschung",
    body: [
      "Ihre Anfragedaten speichern wir nur so lange, wie es für die Bearbeitung und die sich daraus ergebende Zusammenarbeit nötig ist. Sie können jederzeit die Löschung Ihrer Daten verlangen – eine E-Mail genügt.",
    ],
  },
  {
    heading: "5. Übermittlung in die USA und Dienstleister",
    body: [
      "Unser Unternehmen hat seinen Sitz in den USA; Ihre Daten werden daher auch in den USA verarbeitet. Für den Versand von E-Mails (z. B. Bestätigungen und Benachrichtigungen) und für das Hosting dieser Website setzen wir technische Dienstleister ein, die Daten in unserem Auftrag verarbeiten.",
    ],
  },
  {
    heading: "6. Analyse und Schriften",
    body: [
      "Diese Website nutzt einen Analysedienst (PostHog), um die Nutzung der Seite zu verstehen und zu verbessern. Ausserdem laden wir Schriftarten über Google Fonts; dabei wird Ihre IP-Adresse an Google übertragen.",
    ],
  },
  {
    heading: "7. Ihre Rechte",
    body: [
      "Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer Daten sowie das Recht, der Verarbeitung zu widersprechen und sich bei einer Aufsichtsbehörde zu beschweren. Schreiben Sie uns dazu einfach eine E-Mail an reni.a90@hotmail.com.",
    ],
  },
  {
    heading: "8. Hinweis",
    body: [
      "Diese Datenschutzerklärung wurde mit grösster Sorgfalt erstellt und bei Inhalten dieser Website berücksichtigt. Sie ersetzt keine individuelle Rechtsberatung.",
    ],
  },
];

export default function Datenschutz() {
  return (
    <>
      <Seo
        title="Datenschutzerklärung"
        description="Datenschutzerklärung der Elite Swiss LLC: Welche Daten wir über das Kontaktformular verarbeiten, zu welchem Zweck und welche Rechte Sie haben."
      />
      <Header />
      <main className="bg-sand pb-24 pt-36 lg:pt-44" data-testid="datenschutz-page">
        <div className="mx-auto max-w-3xl px-6">
          <h1
            className="font-serif text-4xl tracking-tight text-ink sm:text-5xl"
            data-testid="datenschutz-title"
          >
            Datenschutzerklärung
          </h1>
          <p className="mt-8 border-l-2 border-clay pl-6 font-serif text-xl italic leading-relaxed text-ink-muted">
            Der Schutz Ihrer Daten ist uns wichtig. Hier erklären wir kurz und
            verständlich, was mit Ihren Angaben passiert.
          </p>

          <div className="mt-12 space-y-12">
            {SECTIONS.map((section, i) => (
              <section key={i} data-testid={`datenschutz-section-${i}`}>
                <h2 className="font-serif text-2xl tracking-tight text-ink">
                  {section.heading}
                </h2>
                {section.body.map((p, j) => (
                  <p
                    key={j}
                    className="mt-4 text-base leading-relaxed text-ink-muted"
                  >
                    {p}
                  </p>
                ))}
              </section>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
